'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'NotificationMessage',

    getInitialState: function getInitialState() {
        return { isShowing: true };
    },

    hideNotification: function hideNotification() {
        this.props.handleRemove();
        this.setState({ isShowing: false });
    },

    getClassName: function getClassName() {
        var className = this.props.notification.data.class_name || 'info';
        className += this.state.isShowing ? ' notification-enter' : ' notification-leave';
        return className;
    },

    render: function render() {

        var notification = this.props.notification;
        var className = this.getClassName();
        var styles = this.props.style;
        var text = {
            '__html': notification.data.text || '' // NOTE: We trust this content since it's hard-coded messages
        };

        return _jsx('div', {
            id: notification.id,
            className: className,
            style: styles
        }, void 0, _jsx('div', {
            className: 'columns small-12 text-center'
        }, void 0, _jsx('div', {
            className: 'l-vertical-align-wrapper'
        }, void 0, _jsx('div', {
            className: 'l-vertical-align'
        }, void 0, _jsx('span', {
            className: 'm-notification--close',
            onClick: this.hideNotification
        }, void 0, '×'), _jsx('p', {}, void 0, _jsx('strong', {}, void 0, notification.data.header)), _jsx('p', {
            dangerouslySetInnerHTML: text
        })))));
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/notifications/message.jsx
 ** module id = 624
 ** module chunks = 0
 **/